import Result from "./result";

export class AnticipationResult extends Result {

    public resultType: string = "AnticipationResult";

    /**
     * Which reels will show an anticipation
     */
    public reelAnticipations: boolean[] = [];
    /**
     * Which symbols on each reel should show a land animation
     */
    public landSymbols: string[][] = [];
    /**
     * Which bonuses are lands being counted towards on each reel
     */
    public landBonuses: number[][] = [];

    /**
     * Which reels trigger all symbols of a specified type to begin an anticipation animation
     */
    public anticipateSymbols: string[][] = [];
}
